/**
 * Core
 */
import Vue from 'vue';
import Router from 'vue-router';
import RedirectUtils from './utils.js';

/**
 * Views
 */

import Agents from './../views/Agents.vue';
import Complaints from './../views/Complaints.vue';
import Confirmations from './../views/Confirmations.vue';
import Contacts from './../views/Contacts.vue';
import Containers from './../views/Containers.vue';
import ContainersReservations from './../views/ContainersReservations.vue';
import Contractors from './../views/Contractors.vue';
import Countries from './../views/Countries.vue';
import Currencies from './../views/Currencies.vue';
import Customers from './../views/Customers.vue';
import CustomerContactTypes from './../views/CustomerContactTypes.vue';
import CustomerTags from './../views/CustomerTags.vue';
import DebtReport from './../views/DebtReport.vue';
import EmailTemplates from './../views/EmailTemplates.vue';
import Errors from './../views/Errors.vue';
import Home from './../views/Home.vue';
import IndentRegistry from './../views/IndentRegistry.vue';
import Integrations from './../views/Integrations.vue';
import KpiTargets from './../views/KpiTargets.vue';
import KpiRealization from './../views/KpiRealization.vue';
import Languages from './../views/Languages.vue';
import Login from './../views/Login.vue';
import Logout from './../views/Logout.vue';
import MarketCustomers from './../views/MarketCustomers.vue';
import Notifications from './../views/Notifications.vue';
import Orders from './../views/Orders.vue';
import OrderTags from './../views/OrderTags.vue';
import PotentialCustomers from './../views/PotentialCustomers.vue';
import Prices from './../views/Prices.vue';
import ProcessingTimes from './../views/ProcessingTimes.vue';
import Products from './../views/Products.vue';
import ProductCategories from './../views/ProductCategories.vue';
import ProductTags from './../views/ProductTags.vue';
import Purchases from './../views/Purchases.vue';
import PurchasesReservations from './../views/PurchasesReservations.vue';
import Reports from './../views/Reports.vue';
import Services from './../views/Services.vue';
import ServiceGroups from './../views/ServiceGroups.vue';
import ServicesSchedule from './../views/ServicesSchedule.vue';
import Settings from './../views/Settings.vue';
import Settlements from './../views/Settlements.vue';
import Shipments from './../views/Shipments.vue';
import ShipmentsReports from './../views/ShipmentsReports.vue';
import Shippers from './../views/Shippers.vue';
import Splashscreen from './../views/SplashScreen.vue';
import Statistics from './../views/Statistics.vue';
import Translations from './../views/Translations.vue';
import Users from './../views/Users.vue';
import UserGroups from './../views/UserGroups.vue';
import OrdersHafciarnia from './../views/OrdersHafciarnia.vue';

/**
 * Subviews
 */
import AgentNew from './../components/agents/AgentNew.vue';
import AgentEdit from './../components/agents/AgentEdit.vue';
import ContactNew from './../components/contacts/ContactNew.vue';
import ContactEdit from './../components/contacts/ContactEdit.vue';
import ContainerNew from './../components/containers/ContainerNew.vue';
import ContainerEdit from './../components/containers/ContainerEdit.vue';
import ContractorNew from './../components/contractors/ContractorNew.vue';
import ContractorEdit from './../components/contractors/ContractorEdit.vue';
import ConfirmationNew from './../components/confirmations/ConfirmationNew.vue';
import ConfirmationEdit from './../components/confirmations/ConfirmationEdit.vue';
import CustomerNew from './../components/customers/CustomerNew.vue';
import CustomerEdit from './../components/customers/CustomerEdit.vue';
import CountryNew from './../components/countries/CountryNew.vue';
import CountryEdit from './../components/countries/CountryEdit.vue';
import CurrencyNew from './../components/currencies/CurrencyNew.vue';
import CurrencyEdit from './../components/currencies/CurrencyEdit.vue';
import CustomerContactTypeNew from './../components/customer-contact-types/CustomerContactTypeNew.vue';
import CustomerContactTypeEdit from './../components/customer-contact-types/CustomerContactTypeEdit.vue';
import CustomerTagNew from './../components/customer-tag/CustomerTagNew.vue';
import CustomerTagEdit from './../components/customer-tag/CustomerTagEdit.vue';
import EmailTemplateNew from './../components/email-templates/EmailTemplateNew.vue';
import EmailTemplateEdit from './../components/email-templates/EmailTemplateEdit.vue';
import KpiTargetEdit from './../components/kpi-targets/KpiTargetEdit.vue';
import KpiTargetNew from './../components/kpi-targets/KpiTargetNew.vue';
import LanguageNew from './../components/languages/LanguageNew.vue';
import LanguageEdit from './../components/languages/LanguageEdit.vue';
import MarketCustomerNew from './../components/market-customers/MarketCustomerNew.vue';
import MarketCustomerEdit from './../components/market-customers/MarketCustomerEdit.vue';
import NoPermissions from './../views/NoPermissions.vue';
import NotificationEdit from './../components/notifications/NotificationEdit.vue';
import NotificationNew from './../components/notifications/NotificationNew.vue';
import OrderTagNew from './../components/order-tag/OrderTagNew.vue';
import OrderTagEdit from './../components/order-tag/OrderTagEdit.vue';
import OrderWrapper from './../components/orders/OrderWrapper.vue';
import OrderViewProxy from './../components/orders/OrderViewProxy.vue';
import PotentialCustomersView from './../components/potential-customers/PotentialCustomerView.vue';
import PriceNew from './../components/prices/PriceNew.vue';
import PriceEdit from './../components/prices/PriceEdit.vue';
import ProcessingTimeNew from './../components/processing-times/ProcessingTimeNew.vue';
import ProcessingTimeEdit from './../components/processing-times/ProcessingTimeEdit.vue';
import ProductNew from './../components/products/ProductNew.vue';
import ProductEdit from './../components/products/ProductEdit.vue';
import ProductCategoryNew from './../components/products/ProductCategoryNew.vue';
import ProductCategoryEdit from './../components/products/ProductCategoryEdit.vue';
import ProductTagCategoryNew from './../components/products/ProductTagCategoryNew.vue';
import ProductTagCategoryEdit from './../components/products/ProductTagCategoryEdit.vue';
import Purchase from './../components/purchases/Purchase.vue';
import ServiceNew from './../components/services/ServiceNew.vue';
import RequestWrapper from './../components/orders/RequestWrapper.vue';
import ServiceEdit from './../components/services/ServiceEdit.vue';
import ServiceGroupNew from './../components/services/ServiceGroupNew.vue';
import ServiceGroupEdit from './../components/services/ServiceGroupEdit.vue';
import ShipperNew from './../components/shippers/ShipperNew.vue';
import ShipperEdit from './../components/shippers/ShipperEdit.vue';
import TranslationEdit from './../components/translations/TranslationEdit.vue';
import UserNew from './../components/users/UserNew.vue';
import UserEdit from './../components/users/UserEdit.vue';
import UserGroupNew from './../components/user-groups/UserGroupNew.vue';
import UserGroupEdit from './../components/user-groups/UserGroupEdit.vue';

/**
 * Helpers
 */
import SanitizeUtils from './../utils/SanitizeUtils';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/logowanie',
      component: Login,
      name: 'Logowanie',
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/logowanie/invalid',
      component: Login,
      name: 'Logowanie2',
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/wyloguj',
      component: Logout,
      name: 'Wyloguj'
    },
    {
      path: '/wczytywanie',
      component: Splashscreen,
      name: 'Splashscreen'
    },
    {
      path: '/',
      redirect: '/kokpit'
    },
    {
      path: '/kokpit',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (window.crmApp && !window.crmApp.hasPermissions('home')) {
          next('/zamowienia');
          return;
        }

        RedirectUtils.permissionsCheck('home', next);
      }
    },
    {
      path: '/statystyki',
      component: Statistics,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('stats', next);
      }
    },
    {
      path: '/kategorie-produktow',
      component: ProductCategories,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/kategorie-produktow/nowa',
      component: ProductCategoryNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/kategorie-produktow/edycja/:id',
      component: ProductCategoryEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty',
      component: Products,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty-indent',
      component: Products,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty/nowy',
      component: ProductNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty/edycja/:id',
      component: ProductEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty-indent/nowy',
      component: ProductNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty-indent/edycja/:id',
      component: ProductEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty/tagi',
      component: ProductTags,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty/tagi/nowy',
      component: ProductTagCategoryNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/produkty/tagi/edycja/:id',
      component: ProductTagCategoryEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('products', next);
      }
    },
    {
      path: '/zdobienia',
      component: Services,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia/nowe',
      component: ServiceNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia/edycja/:id',
      component: ServiceEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia-indent',
      component: Services,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia-indent/nowe',
      component: ServiceNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia-indent/edycja/:id',
      component: ServiceEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia/grupy',
      component: ServiceGroups,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia/grupy/nowa',
      component: ServiceGroupNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/zdobienia/grupy/edycja/:id',
      component: ServiceGroupEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services', next);
      }
    },
    {
      path: '/kontenery',
      component: Containers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('containers', next);
      }
    },
    {
      path: '/kontenery/nowy',
      component: ContainerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('containers', next);
      }
    },
    {
      path: '/kontenery/edycja/:id',
      component: ContainerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('containers', next);
      }
    },
    {
      path: '/kontenery/edycja/:id/:fromreservations',
      component: ContainerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('containers', next);
      }
    },
    {
      path: '/kontenery/rezerwacje',
      component: ContainersReservations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('containers', next);
      }
    },
    {
      path: '/wykonawcy',
      component: Contractors,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contractors', next);
      }
    },
    {
      path: '/wykonawcy/nowy',
      component: ContractorNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contractors', next);
      }
    },
    {
      path: '/wykonawcy/edycja/:id',
      component: ContractorEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contractors', next);
      }
    },
    {
      path: '/cenniki/produkty',
      component: Prices,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/produkty/nowy',
      component: PriceNew,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/produkty/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'products'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/zdobienia',
      component: Prices,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/zdobienia/nowy',
      component: PriceNew,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/zdobienia/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'services'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/setup',
      component: Prices,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/setup/nowy',
      component: PriceNew,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/cenniki/setup/edycja/:id',
      component: PriceEdit,
      meta: {
        type: 'setups'
      },
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('prices', next);
      }
    },
    {
      path: '/agenci',
      component: Agents,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('agents', next);
      }
    },
    {
      path: '/agenci/nowy',
      component: AgentNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('agents', next);
      }
    },
    {
      path: '/agenci/edycja/:id',
      component: AgentEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('agents', next);
      }
    },
    {
      path: '/klienci',
      component: Customers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('customers', next);
      }
    },
    {
      path: '/klienci/nowy',
      component: CustomerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('customers', next);
      }
    },
    {
      path: '/klienci/nowy/z-potencjalnego-klienta/:potentialid',
      component: CustomerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('customers', next);
      }
    },
    {
      path: '/klienci/nowy/z-klienta-z-targow/:marketid',
      component: CustomerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('customers', next);
      }
    },
    {
      path: '/klienci/edycja/:id',
      component: CustomerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('customers', next);
      }
    },
    {
      path: '/kontakty-z-klientami',
      component: Contacts,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contacts', next);
      }
    },
    {
      path: '/kontakty-z-klientami/nowy',
      component: ContactNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contacts', next);
      }
    },
    {
      path: '/kontakty-z-klientami/edycja/:id',
      component: ContactEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('contacts', next);
      }
    },
    {
      path: '/cele-pracownikow',
      component: KpiTargets,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('kpi_targets', next);
      }
    },
    {
      path: '/cele-pracownikow/nowy',
      component: KpiTargetNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('kpi_targets', next);
      }
    },
    {
      path: '/cele-pracownikow/nowy/duplikuj/:duplicate_from_id',
      component: KpiTargetNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('kpi_targets', next);
      }
    },
    {
      path: '/cele-pracownikow/edycja/:id',
      component: KpiTargetEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('kpi_targets', next);
      }
    },
    {
      path: '/realizacja-kpi',
      component: KpiRealization,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('kpi_targets', next);
      }
    },
    {
      path: '/moje-konto',
      component: CustomerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('profile', next);
      }
    },
    {
      path: '/zamowienia',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-wszystkie/',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-wszystkie/podglad/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty-indent',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/do-sprawdzenia',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oczekujace-na-dostawe',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty/nowa/',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty-indent/nowa/',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/nowe/',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/edycja/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-indent',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-indent/nowe/',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-indent/edycja/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia/edycja/:id/:fromreservations',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty/edycja/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/oferty-indent/edycja/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-partnerow',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zapytania',
      component: Orders,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zapytania/nowe',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zapytania/nowe/:product_id',
      component: RequestWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zapytania/zapytanie/:id',
      component: OrderViewProxy,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/ustawienia/spedytorzy',
      component: Shippers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('shippers', next);
      }
    },
    {
      path: '/ustawienia/spedytorzy/nowy',
      component: ShipperNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('shippers', next);
      }
    },
    {
      path: '/ustawienia/spedytorzy/edycja/:id',
      component: ShipperEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('shippers', next);
      }
    },
    {
      path: '/rozliczenia',
      component: Settlements,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settlements', next);
      }
    },
    {
      path: '/raport-zadluzen',
      component: DebtReport,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settlements', next);
      }
    },
    {
      path: '/planowanie-zdobien',
      component: ServicesSchedule,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('services_schedule', next);
      }
    },
    {
      path: '/raporty',
      component: Reports,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('reports', next);
      }
    },
    {
      path: '/uzytkownicy',
      component: Users,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/uzytkownicy/nowy',
      component: UserNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/uzytkownicy/edycja/:id',
      component: UserEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/rejestr-indent',
      component: IndentRegistry,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-hafciarnia',
      component: OrdersHafciarnia,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/zamowienia-hafciarnia/edycja/:id',
      component: OrderWrapper,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('orders', next);
      }
    },
    {
      path: '/ustawienia',
      component: Settings,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/kraje',
      component: Countries,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/kraje/nowy',
      component: CountryNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/kraje/edycja/:id',
      component: CountryEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/waluty',
      component: Currencies,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/waluty/nowa',
      component: CurrencyNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/waluty/edycja/:id',
      component: CurrencyEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/potwierdzenia',
      component: Confirmations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/potwierdzenia/nowe',
      component: ConfirmationNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/potwierdzenia/edycja/:id',
      component: ConfirmationEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/jezyki',
      component: Languages,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/jezyki/nowy',
      component: LanguageNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/jezyki/edycja/:id',
      component: LanguageEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/slowniki-wielojezycznosci',
      component: Translations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/slowniki-wielojezycznosci/edycja/:id',
      component: TranslationEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-klientow',
      component: CustomerTags,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-klientow/nowy',
      component: CustomerTagNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-klientow/edycja/:id',
      component: CustomerTagEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/typy-kontaktow-z-klientem',
      component: CustomerContactTypes,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/typy-kontaktow-z-klientem/nowy',
      component: CustomerContactTypeNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/typy-kontaktow-z-klientem/edycja/:id',
      component: CustomerContactTypeEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-zamowien',
      component: OrderTags,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-zamowien/nowy',
      component: OrderTagNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/tagi-zamowien/edycja/:id',
      component: OrderTagEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/czas-realizacji',
      component: ProcessingTimes,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/czas-realizacji/nowy',
      component: ProcessingTimeNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/czas-realizacji/edycja/:id',
      component: ProcessingTimeEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/integracje',
      component: Integrations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/grupy-uzytkownikow',
      component: UserGroups,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/ustawienia/grupy-uzytkownikow/nowa',
      component: UserGroupNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/ustawienia/grupy-uzytkownikow/edycja/:id',
      component: UserGroupEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('users', next);
      }
    },
    {
      path: '/ustawienia/szablony-email',
      component: EmailTemplates,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/szablony-email/nowy',
      component: EmailTemplateNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/ustawienia/szablony-email/edycja/:id',
      component: EmailTemplateEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('settings', next);
      }
    },
    {
      path: '/zakupy',
      component: Purchases,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('purchases', next);
      }
    },
    {
      path: '/zakupy/nowe',
      component: Purchase,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('purchases', next);
      }
    },
    {
      path: '/zakupy/edycja/:id',
      component: Purchase,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('purchases', next);
      }
    },
    {
      path: '/zakupy/edycja/:id/:fromreservations',
      component: Purchase,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('purchases', next);
      }
    },
    {
      path: '/zakupy/rezerwacje',
      component: PurchasesReservations,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('purchases', next);
      }
    },
    {
      path: '/reklamacje',
      component: Complaints,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('complaints', next);
      }
    },
    {
      path: '/przesylki',
      component: Shipments,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('shipments', next);
      }
    },
    {
      path: '/przesylki-raporty',
      component: ShipmentsReports,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('shipments', next);
      }
    },
    {
      path: '/powiadomienia',
      component: Notifications,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('notifications', next);
      }
    },
    {
      path: '/powiadomienia/najblizsze',
      component: Notifications,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('notifications', next);
      },
      meta: {
        showDashboardResults: true
      }
    },
    {
      path: '/powiadomienia/nowe',
      component: NotificationNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('notifications', next);
      }
    },
    {
      path: '/powiadomienia/edycja/:id',
      component: NotificationEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('notifications', next);
      }
    },
    {
      path: '/potencjalni-klienci',
      component: PotentialCustomers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('potential_customers', next);
      }
    },
    {
      path: '/potencjalni-klienci/podglad/:id',
      component: PotentialCustomersView,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('potential_customers', next);
      }
    },
    {
      path: '/klienci-z-targow',
      component: MarketCustomers,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('market_customers', next);
      }
    },
    {
      path: '/klienci-z-targow/nowy',
      component: MarketCustomerNew,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('market_customers', next);
      }
    },
    {
      path: '/klienci-z-targow/edycja/:id',
      component: MarketCustomerEdit,
      beforeEnter: (to, from, next) => {
        RedirectUtils.permissionsCheck('market_customers', next);
      }
    },
    {
      path: '/404',
      component: Errors
    },
    {
      path: '/brak-uprawnien',
      component: NoPermissions
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

router.beforeEach((to, from, next) => {
  let notLoggedInRoutes = [
    'Logowanie',
    'Logowanie2',
    'Wyloguj'
  ];

  if (notLoggedInRoutes.indexOf(to.name) === -1 && !SanitizeUtils.getToken()) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next({ name: 'Logowanie' });
    return;
  }

  if (notLoggedInRoutes.indexOf(to.name) !== -1) {
    let splashscreenHtml = document.querySelector('#splashscreen');

    if (splashscreenHtml) {
      splashscreenHtml.parentNode.removeChild(splashscreenHtml);
    }

    next();
    return;
  }

  if (!window.crmApp) {
    setTimeout(() => {
      next({
        name: 'Splashscreen',
        params: {
          nextRoute: to.path
        }
      });

      let splashscreenHtml = document.querySelector('#splashscreen');

      if (splashscreenHtml) {
        splashscreenHtml.parentNode.removeChild(splashscreenHtml);
      }
    }, 0);

    return;
  }

  if (from && from.path) {
    sessionStorage.setItem('headwear-crm-previous-view', from.path);
  }

  next();
});

export default router;
